export default {
  POLICY_TYPE: "policy_type",
  DETAILS: "details",
  COVERAGES: "coverages",
  PREMIUMS: "premiums",
};
